import { type ReactNode, type Ref } from 'react';
import { Link } from '@tanstack/react-router';
import { t } from '@lingui/core/macro';
import ThemeLogo from '../ui/ThemeLogo';

interface SidebarNavShellProps {
  ariaBusy?: boolean;
  scrollerRef?: Ref<HTMLDivElement>;
  scrollerHeader?: ReactNode;
  footer?: ReactNode;
  navExtras?: ReactNode;
  children: ReactNode;
}

function SidebarNavShell({
  ariaBusy,
  scrollerRef,
  scrollerHeader,
  footer,
  navExtras,
  children,
}: SidebarNavShellProps) {
  return (
    <nav className="side-nav" aria-label={t`Menu`} aria-busy={ariaBusy}>
      <div className="side-nav-logo">
        <Link to="/" className="side-nav-logo-link">
          <ThemeLogo className="app-logo" />
        </Link>
      </div>

      <div ref={scrollerRef} className="side-nav-scroller" data-testid="nav-scroller">
        {scrollerHeader}
        {children}
      </div>

      {footer}
      {navExtras}
    </nav>
  );
}

export default SidebarNavShell;
